export default __webpack_public_path__ + "static/media/159.6b4776ac.jpg";